import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './all.scss';
import { withPrefix } from 'gatsby';
import { PageWrapper, TrackingRootProvider } from '@minware/ui-minware';
import LinkType from './LinkType';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from './ErrorPage';

// Load this here so that it's included on all pages
import '../analytics';
import { track, trackError } from '../analytics';
import { navBarItems } from '../lib/navBarItems';
import { footerItems } from '../lib/footerItems';

if (typeof window !== 'undefined') {
  window.addEventListener('error', event => {
    event.stopPropagation();
    console.log('error', event);
  });
}

const Layout = ({ children, desktopBgImageName, gap }) => {
  // WARNING: this must be kept in sync with app, which hosts survey pre-auth pages
  return (
    <TrackingRootProvider track={track}>
      <div>
        <Helmet>
          <html lang="en" />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href={`${withPrefix('/')}img/apple-touch-icon.png`}
          />
          <link
            rel="icon"
            type="image/png"
            href={`${withPrefix('/')}img/favicon-32x32.png`}
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href={`${withPrefix('/')}img/favicon-16x16.png`}
            sizes="16x16"
          />

          <link
            rel="mask-icon"
            href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
            color="#166df8"
          />
          <meta name="theme-color" content="#fff" />
        </Helmet>

        <PageWrapper
          linkType={LinkType}
          onHamburgerClick={() => {
            alert('hambuger clicked');
          }}
          logoLink="/"
          loginLink="/api/auth/login"
          signUpLink="/api/auth/login?signup=1"
          navbarItems={navBarItems}
          footerItems={footerItems}
          termsLink="/terms"
          privacyLink="/privacy"
          desktopBgImageName={desktopBgImageName === 'none'
            ? null
            : (desktopBgImageName || 'otherDesktop')}
          gap={gap}
        >
          <ErrorBoundary
            fallback={<ErrorPage title="Error" subtitle="An error occurred" />}
            onError={trackError}
          >
            {children}
          </ErrorBoundary>
        </PageWrapper>
      </div>
    </TrackingRootProvider>
  );
};

export default Layout;
